export default __webpack_public_path__ + "static/media/B101.305ce9cc.png";